import { CSSProperties, MouseEventHandler } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { RootState } from "redux/store";
import "./style.css";

export const Tab = ({
  id,
  icon,
  label,
  onClick,
  isActive,
  isLogout,
  style,
}: {
  id?: string;
  icon?: string;
  label: string;
  onClick?: MouseEventHandler;
  isActive?: boolean;
  isLogout?: boolean;
  style?: CSSProperties;
}) => {
  // Global States
  const { sideBar } = useSelector(
    (state: RootState) => ({
      sideBar: state?.sideBar,
    }),
    shallowEqual
  );
  return (
    <div
      className={`Tab ${isActive && "Tab_active"} ${
        isLogout && "logoutTab"
      } unselectable clickable`}
      onClick={onClick}
      id={id}
      style={{
        ...style,
        justifyContent:
          sideBar?.mode === "expanded" ? "space-between" : "center",
      }}
      title={label}
    >
      <div className="iconAndName">
        {icon ? (
          <div className="iconContainer">
            <img className="icon" src={icon} alt="icon" />
          </div>
        ) : null}
        {sideBar?.mode === "expanded" ? <p className="name">{label}</p> : null}
      </div>
    </div>
  );
};
